export default {
  icmcApi: {
    getConsultingHis: 'api/lawyerMC/getUserConsulting',
    getDetail: 'api/lawyerMC/getMCInfo',
    reply: {
      //回复模块
      getList: 'api/icmc/consultationReply/getList',
      reply: 'api/icmc/consultationReply/reply',
    },
    audit: {
      //审核模块
      getList: 'api/icmc/consultationAudit/getList',
      audit: 'api/icmc/consultationAudit/audit',
      exportFinished: 'api/icmc/consultationAudit/exportFinished',
    },
    mcStatistics: {
      getList: 'api/mcStatistics/getList',
      exportData: 'api/mcStatistics/exportData'
    },
    history: {
      getList: 'api/icmc/consultationHistory/getHistoryList',
      export: 'api/icmc/consultationHistory/exportFinished',
    }
  }
}